import { Result, Button } from "antd";
import { useRouteError } from "react-router-dom";
import { useAppTranslation } from "~/hooks/useAppTranslation";

export const GenericErrorBoundary = () => {
  const error = useRouteError();
  const { t } = useAppTranslation();
  console.error("An error occured on this page", error);
  return (
    <Result status="500" title="500" subTitle={t("Sorry_something_went_wrong")}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
